<div class="table-wrapper">
  <table class="product-table">
    <thead>
      <tr>
        <th colspan="3">Inquiry</th>
        <th colspan="3">Ready to dispatch</th>
        <th colspan="3">In transit</th>
        <th colspan="3">Delivered</th>
      </tr>
      <tr>
        <th>Product &amp; Size</th>
        <th>Weight (KG)</th>
        <th>Qty (Box)</th>

        <th>Product &amp; Size</th>
        <th>Weight (KG)</th>
        <th>Qty (Box)</th>

        <th>Product &amp; Size</th>
        <th>Weight (KG)</th>
        <th>Qty (Box)</th>

        <th>Product &amp; Size</th>
        <th>Weight (KG)</th>
        <th>Qty (Box)</th>
      </tr>
    </thead>

    <tbody>
      <!-- one row per product -->
      <tr *ngFor="let row of rows">
        <!-- Inquiry -->
        <td>{{ row.productName }} {{ row.productSize }}</td>
        <td>{{ row.requestedWeight }}KG</td>
        <td>{{ row.requestedQty }}</td>

        <!-- Ready to dispatch (loaded) -->
        <td>{{ row.productName }} {{ row.productSize }}</td>
        <td>
          {{ row.readyWeight }}KG
          <div
            *ngIf="
              row.readyWeightDiff !== undefined && row.readyWeightDiff !== 0
            "
            [ngClass]="diffClass(row.readyWeightDiff)"
          >
            {{ formatDiff(row.readyWeightDiff) }}
          </div>
        </td>
        <td>
          {{ row.readyQty }}
          <div
            *ngIf="row.readyQtyDiff !== undefined && row.readyQtyDiff !== 0"
            [ngClass]="diffClass(row.readyQtyDiff)"
          >
            {{ formatDiff(row.readyQtyDiff) }}
          </div>
        </td>

        <!-- Dispatch -->
        <td>{{ row.productName }} {{ row.productSize }}</td>
        <td>
          {{ row.dispatchedWeight }}KG
          <div
            *ngIf="
              row.dispatchedWeightDiff !== undefined &&
              row.dispatchedWeightDiff !== 0
            "
            >
            <!-- [ngClass]="diffClass(row.dispatchedWeightDiff)" -->
            <!-- {{ formatDiff(row.dispatchedWeightDiff) }} -->
          </div>
        </td>
        <td>
          {{ row.dispatchedQty }}
          <div
            *ngIf="
              row.dispatchedQtyDiff !== undefined && row.dispatchedQtyDiff !== 0
            "
            >
            <!-- [ngClass]="diffClass(row.dispatchedQtyDiff)" -->
            <!-- {{ formatDiff(row.dispatchedQtyDiff) }} -->
          </div>
        </td>

        <!-- Delivered -->
        <td>{{ row.productName }} {{ row.productSize }}</td>
        <td>
          {{ row.deliveredWeight }}KG
          <div
            *ngIf="
              row.deliveredWeightDiff !== undefined &&
              row.deliveredWeightDiff !== 0
            "
            [ngClass]="diffClass(row.deliveredWeightDiff)"
          >
            {{ formatDiff(row.deliveredWeightDiff) }}
          </div>
        </td>
        <td>
          {{ row.deliveredQty }}
          <div
            *ngIf="
              row.deliveredQtyDiff !== undefined && row.deliveredQtyDiff !== 0
            "
            [ngClass]="diffClass(row.deliveredQtyDiff)"
          >
            {{ formatDiff(row.deliveredQtyDiff) }}
          </div>
        </td>
      </tr>

      <!-- totals row -->
      <tr class="total-row">
        <td><strong>Total</strong></td>
        <td>
          <strong>{{ totals.requestedWeight }}</strong>
        </td>
        <td>
          <strong>{{ totals.requestedQty }}</strong>
        </td>

        <td><strong>Total</strong></td>
        <td>
          <strong>{{ totals.readyWeight }}</strong>
        </td>
        <td>
          <strong>{{ totals.readyQty }}</strong>
        </td>

        <td><strong>Total</strong></td>
        <td>
          <strong>{{ totals.dispatchedWeight }}</strong>
        </td>
        <td>
          <strong>{{ totals.dispatchedQty }}</strong>
        </td>

        <td><strong>Total</strong></td>
        <td>
          <strong>{{ totals.deliveredWeight }}</strong>
        </td>
        <td>
          <strong>{{ totals.deliveredQty }}</strong>
        </td>
      </tr>
    </tbody>
  </table>
</div>
